import { useCallback, useMemo } from 'react';

import { useSelector } from 'react-redux';

import config from 'app.config';
import { selectDataMatchId } from 'connect/selectors';
import { RECOMMENDATION_PATH, RESULTS_PATH } from 'containers/App/Routes';

import { useRedirectionService } from './RedirectionService';

export const useRedirectFindNewDentist = () => {
  const matchId = useSelector(selectDataMatchId);

  const redirectionService = useRedirectionService();

  const newBookingUrl = useMemo(() => {
    if (matchId) {
      return `${config.SEARCH_APP_V2_URL}${RESULTS_PATH}`;
    }

    return `${config.SEARCH_APP_V2_URL}${RECOMMENDATION_PATH}`;
  }, [matchId]);

  const redirectFindNewDentist = useCallback(() => {
    redirectionService.redirect({
      url: newBookingUrl,
      reason: 'restricted-patient-book-with-other-dentists',
    });
  }, [newBookingUrl, redirectionService]);

  return redirectFindNewDentist;
};
